import { render, staticRenderFns } from "./OrdersHistory.vue?vue&type=template&id=e141e6b6&"
import script from "./OrdersHistory.vue?vue&type=script&lang=js&"
export * from "./OrdersHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports